// import React, { useState, useEffect } from "react";
// import css from "./uthorListEditor.module.css";
// import {
//   getStorage,
//   ref,
//   getDownloadURL,
//   uploadBytesResumable,
//   deleteObject,
// } from "firebase/storage";
// import {
//   collection,
//   doc,
//   getDocs,
//   updateDoc,
//   deleteDoc,
// } from "firebase/firestore";
// import { db } from "../../firebase";
// import Swal from "sweetalert2";

// const AuthorListEditor = () => {
//   const storage = getStorage();
//   const [authors, setAuthors] = useState([]);
//   const [selectedAuthor, setSelectedAuthor] = useState(null);
//   const [newImage, setNewImage] = useState(null);
//   const [updatedData, setUpdatedData] = useState({});

//   // 🔹 Перелік всіх полів, як у `AutorAdm.js`
//   const objList = [
//     { name: "Ім'я", transliter: "name" },
//     { name: "Опис 1", transliter: "descOne" },
//     { name: "Опис 2", transliter: "descSecond" },
//     { name: "Книга", transliter: "book" },
//     { name: "Малий опис", transliter: "smallDesc" },
//     { name: "Історія створення", transliter: "history" },
//     { name: "Інтерв'ю 1", transliter: "internOne" },
//     { name: "Інтерв'ю 2", transliter: "internSecond" },
//     { name: "Відео (ID YouTube)", transliter: "video" },
//     { name: "Фото", transliter: "foto" },
//   ];

//   useEffect(() => {
//     const fetchAuthors = async () => {
//       const authorsCollection = collection(db, "author");
//       const authorsSnapshot = await getDocs(authorsCollection);
//       const authorsData = authorsSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setAuthors(authorsData);
//     };

//     fetchAuthors();
//   }, []);

//   const handleSelectAuthor = (author) => {
//     setSelectedAuthor(author);
//     setUpdatedData(author);
//     setNewImage(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setUpdatedData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleUpdateAuthor = async () => {
//     if (selectedAuthor) {
//       try {
//         const authorRef = doc(db, "author", selectedAuthor.id);
//         await updateDoc(authorRef, updatedData);

//         setAuthors((prevAuthors) =>
//           prevAuthors.map((author) =>
//             author.id === selectedAuthor.id
//               ? { ...author, ...updatedData }
//               : author
//           )
//         );

//         Swal.fire({
//           title: "Успішно!",
//           text: "Дані автора оновлено",
//           icon: "success",
//           confirmButtonText: "OK",
//         });

//         setSelectedAuthor(null);
//       } catch (error) {
//         Swal.fire({
//           title: "Помилка",
//           text: `Не вдалося оновити дані: ${error.message}`,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     }
//   };

//   const handleUpdateImage = async () => {
//     if (newImage && selectedAuthor) {
//       const imageRef = ref(storage, `authors/${newImage.name}`);
//       const uploadTask = uploadBytesResumable(imageRef, newImage);

//       uploadTask.on(
//         "state_changed",
//         (snapshot) => {
//           const progress =
//             (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//           Swal.fire({
//             title: "Завантаження...",
//             text: `Прогрес: ${progress.toFixed(2)}%`,
//             icon: "info",
//             showConfirmButton: false,
//           });
//         },
//         (error) => {
//           Swal.fire({
//             title: "Помилка",
//             text: `Не вдалося завантажити фото: ${error.message}`,
//             icon: "error",
//             confirmButtonText: "OK",
//           });
//         },
//         async () => {
//           const imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
//           const authorRef = doc(db, "author", selectedAuthor.id);
//           await updateDoc(authorRef, { foto: imageUrl });

//           setAuthors((prevAuthors) =>
//             prevAuthors.map((author) =>
//               author.id === selectedAuthor.id
//                 ? { ...author, foto: imageUrl }
//                 : author
//             )
//           );

//           setSelectedAuthor((prevAuthor) => ({
//             ...prevAuthor,
//             foto: imageUrl,
//           }));
//           setNewImage(null);

//           Swal.fire({
//             title: "Успішно!",
//             text: "Фото оновлено",
//             icon: "success",
//             confirmButtonText: "OK",
//           });
//         }
//       );
//     }
//   };

//   const handleDeleteAuthor = async () => {
//     if (selectedAuthor) {
//       const confirmResult = await Swal.fire({
//         title: "Ви впевнені?",
//         text: "Цей автор буде повністю видалений!",
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonText: "Так",
//         cancelButtonText: "Ні",
//       });

//       if (confirmResult.isConfirmed) {
//         await deleteDoc(doc(db, "author", selectedAuthor.id));

//         if (selectedAuthor.foto) {
//           const imageRef = ref(storage, selectedAuthor.foto);
//           await deleteObject(imageRef);
//         }

//         setAuthors((prevAuthors) =>
//           prevAuthors.filter((author) => author.id !== selectedAuthor.id)
//         );

//         setSelectedAuthor(null);

//         Swal.fire("Видалено!", "Автор був видалений.", "success");
//       }
//     }
//   };

//   return (
//     <div className={css.allWrapForAutor}>
//       <h2>Список авторів</h2>
//       <ul className={css.ulHer}>
//         {authors.map((author) => (
//           <li key={author.id} className={css.wrapAllPHL}>
//             <h3>{author.name}</h3>
//             {author.foto && (
//               <div className={css.wrapHeroF}>
//                 <img src={author.foto} alt={`Author ${author.name}`} />
//               </div>
//             )}
//             <button onClick={() => handleSelectAuthor(author)}>
//               {selectedAuthor?.id === author.id ? "Закрити" : "Редагувати"}
//             </button>
//           </li>
//         ))}
//       </ul>

//       {selectedAuthor && (
//         <div className={css.editForm}>
//           <h3>Редагування автора</h3>
//           {objList.map((el, index) => (
//             <div key={index}>
//               <label>{el.name}:</label>
//               {el.transliter === "foto" ? (
//                 <input
//                   type="file"
//                   onChange={(e) => setNewImage(e.target.files[0])}
//                 />
//               ) : (
//                 <textarea
//                   name={el.transliter}
//                   value={updatedData[el.transliter] || ""}
//                   onChange={handleInputChange}
//                 />
//               )}
//             </div>
//           ))}
//           <button onClick={handleUpdateAuthor}>Зберегти зміни</button>
//           <button onClick={handleUpdateImage}>Оновити фото</button>
//           <button onClick={handleDeleteAuthor}>Видалити автора</button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AuthorListEditor;

import React, { useState, useEffect } from "react";
import css from "./uthorListEditor.module.css";
import {
  getStorage,
  ref,
  getDownloadURL,
  uploadBytesResumable,
  deleteObject,
} from "firebase/storage";
import {
  collection,
  doc,
  getDocs,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";

const AuthorListEditor = () => {
  const storage = getStorage();

  const [authors, setAuthors] = useState([]);
  const [selectedAuthor, setSelectedAuthor] = useState(null);
  const [newImage, setNewImage] = useState(null);
  const [updatedData, setUpdatedData] = useState({});

  const objList = [
    { name: "Ім'я", transliter: "name" },
    { name: "Опис 1", transliter: "descOne" },
    { name: "Опис 2", transliter: "descSecond" },
    { name: "Книга", transliter: "book" },
    { name: "Малий опис", transliter: "smallDesc" },
    { name: "Історія створення", transliter: "history" },
    { name: "Інтерв'ю 1", transliter: "internOne" },
    { name: "Інтерв'ю 2", transliter: "internSecond" },
    { name: "Відео (ID YouTube)", transliter: "video" },
    { name: "Фото", transliter: "foto" },
  ];

  useEffect(() => {
    const fetchAuthors = async () => {
      try {
        const authorsCollection = collection(db, "author");
        const authorsSnapshot = await getDocs(authorsCollection);

        const authorsData = authorsSnapshot.docs.map((docItem) => ({
          id: docItem.id,
          ...docItem.data(),
        }));

        setAuthors(authorsData);
      } catch (error) {
        Swal.fire({
          title: "Помилка",
          text: `Не вдалося завантажити авторів: ${error.message}`,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    };

    fetchAuthors();
  }, []);

  const handleSelectAuthor = (author) => {
    if (selectedAuthor?.id === author.id) {
      setSelectedAuthor(null);
      setUpdatedData({});
      setNewImage(null);
      return;
    }

    setSelectedAuthor(author);
    setUpdatedData({
      ...author,
      foto: author.foto || "",
    });
    setNewImage(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setUpdatedData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const uploadAuthorImage = async () => {
    if (!newImage || !selectedAuthor) return null;

    const safeFileName = `${Date.now()}-${newImage.name
      .replace(/\s+/g, "-")
      .replace(/[^\w.-]/g, "")}`;

    const imageRef = ref(
      storage,
      `authors/${selectedAuthor.id}/${safeFileName}`,
    );
    const uploadTask = uploadBytesResumable(imageRef, newImage);

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          Swal.fire({
            title: "Завантаження фото...",
            text: `Прогрес: ${progress.toFixed(0)}%`,
            icon: "info",
            showConfirmButton: false,
            allowOutsideClick: false,
          });
        },
        (error) => {
          reject(error);
        },
        async () => {
          try {
            const imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
            resolve(imageUrl);
          } catch (error) {
            reject(error);
          }
        },
      );
    });
  };

  const deleteOldImage = async (oldImageUrl, newImageUrl) => {
    if (!oldImageUrl || oldImageUrl === newImageUrl) return;

    try {
      const oldImageRef = ref(storage, oldImageUrl);
      await deleteObject(oldImageRef);
    } catch (error) {
      console.warn("Старе фото не видалено:", error);
    }
  };

  const handleUpdateAuthor = async () => {
    if (!selectedAuthor) return;

    try {
      const authorRef = doc(db, "author", selectedAuthor.id);

      let dataToUpdate = {
        ...updatedData,
      };

      if (newImage) {
        const newImageUrl = await uploadAuthorImage();

        if (newImageUrl) {
          await deleteOldImage(selectedAuthor.foto, newImageUrl);

          dataToUpdate = {
            ...dataToUpdate,
            foto: newImageUrl,
          };
        }
      }

      await updateDoc(authorRef, dataToUpdate);

      setAuthors((prevAuthors) =>
        prevAuthors.map((author) =>
          author.id === selectedAuthor.id
            ? {
                ...author,
                ...dataToUpdate,
              }
            : author,
        ),
      );

      setSelectedAuthor((prevAuthor) => ({
        ...prevAuthor,
        ...dataToUpdate,
      }));

      setUpdatedData((prevData) => ({
        ...prevData,
        ...dataToUpdate,
      }));

      setNewImage(null);

      Swal.fire({
        title: "Успішно!",
        text: "Дані автора оновлено",
        icon: "success",
        confirmButtonText: "OK",
      });

      setSelectedAuthor(null);
      setUpdatedData({});
    } catch (error) {
      Swal.fire({
        title: "Помилка",
        text: `Не вдалося оновити дані автора: ${error.message}`,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleDeleteAuthor = async () => {
    if (!selectedAuthor) return;

    const confirmResult = await Swal.fire({
      title: "Ви впевнені?",
      text: "Цей автор буде повністю видалений!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Так",
      cancelButtonText: "Ні",
    });

    if (!confirmResult.isConfirmed) return;

    try {
      await deleteDoc(doc(db, "author", selectedAuthor.id));

      if (selectedAuthor.foto) {
        try {
          const imageRef = ref(storage, selectedAuthor.foto);
          await deleteObject(imageRef);
        } catch (error) {
          console.warn("Фото автора не видалено зі Storage:", error);
        }
      }

      setAuthors((prevAuthors) =>
        prevAuthors.filter((author) => author.id !== selectedAuthor.id),
      );

      setSelectedAuthor(null);
      setUpdatedData({});
      setNewImage(null);

      Swal.fire({
        title: "Видалено!",
        text: "Автор був видалений.",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      Swal.fire({
        title: "Помилка",
        text: `Не вдалося видалити автора: ${error.message}`,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className={css.allWrapForAutor}>
      <h2>Список авторів</h2>

      <ul className={css.ulHer}>
        {authors.map((author) => (
          <li key={author.id} className={css.wrapAllPHL}>
            <h3>{author.name}</h3>

            {author.foto && (
              <div className={css.wrapHeroF}>
                <img src={author.foto} alt={`Author ${author.name}`} />
              </div>
            )}

            <button onClick={() => handleSelectAuthor(author)}>
              {selectedAuthor?.id === author.id ? "Закрити" : "Редагувати"}
            </button>
          </li>
        ))}
      </ul>

      {selectedAuthor && (
        <div className={css.editForm}>
          <h3>Редагування автора</h3>

          {objList.map((el) => (
            <div key={el.transliter}>
              <label>{el.name}:</label>

              {el.transliter === "foto" ? (
                <div>
                  {updatedData?.foto && (
                    <div className={css.wrapHeroF}>
                      <img
                        src={updatedData.foto}
                        alt={`Author ${updatedData.name || ""}`}
                      />
                    </div>
                  )}

                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      setNewImage(file || null);
                    }}
                  />

                  {newImage && <p>Нове фото вибрано: {newImage.name}</p>}
                </div>
              ) : (
                <textarea
                  name={el.transliter}
                  value={updatedData[el.transliter] || ""}
                  onChange={handleInputChange}
                />
              )}
            </div>
          ))}

          <button onClick={handleUpdateAuthor}>Зберегти зміни</button>
          <button onClick={handleDeleteAuthor}>Видалити автора</button>
        </div>
      )}
    </div>
  );
};

export default AuthorListEditor;
